// extracted by mini-css-extract-plugin
module.exports = {"insights":"insights_insights__17aN8","threat_types_container":"insights_threat_types_container__Y65vX","threat_groups_container":"insights_threat_groups_container__AKAkj"};